import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add choice", -1)

import Button from 'primevue/button';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), { class: "p-button-text" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})